import Vue from 'vue';
import Vuex from 'vuex';
import { Module, createVuexStore } from 'vuex-simple';
import { SettingsStore } from './settings';

Vue.use(Vuex);

export class RootStore {
  @Module()
  public settingsStore = new SettingsStore();
}

export const rootStore = new RootStore();

export default createVuexStore(rootStore, {
  strict: false,
  modules: {},
  plugins: [],
});
